import { render, staticRenderFns } from "./addEdit.vue?vue&type=template&id=2011063c&scoped=true"
import script from "./addEdit.vue?vue&type=script&lang=js"
export * from "./addEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2011063c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2011063c')) {
      api.createRecord('2011063c', component.options)
    } else {
      api.reload('2011063c', component.options)
    }
    module.hot.accept("./addEdit.vue?vue&type=template&id=2011063c&scoped=true", function () {
      api.rerender('2011063c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/route/managementMailingRules/cmp/addEdit.vue"
export default component.exports